export default "__VITE_ASSET__7e59d291__"